// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntr[data-v-93a77dce] {\n  padding: 0 16px;\n}\ntr .btn-copy[data-v-93a77dce] {\n  display: none;\n}\ntr:hover .btn-copy[data-v-93a77dce] {\n  display: block;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
